import React, { useCallback, useRef } from 'react'
import MerchandiseSearchFilters, { MerchandiseFilterFacetForm } from './MerchandiseSearchFilters'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import FormModal from 'LuxKit/Modal/FormModal'
import { useIntl } from 'react-intl'

interface Props {
  userFilters: App.MerchandiseFilters
  category?: App.MerchandiseCategory
  urlFilters: App.MerchandiseFilters
  children?: React.ReactNode
}

/**
 * Simple modal wrapper for MerchandiseSearchFilters
 * All business logic lives in MerchandiseSearchFilters component
 */
function MerchandiseSearchFilterModal(props: Props) {
  const { userFilters, category, urlFilters, children } = props
  const intl = useIntl()

  const { resolve } = useModalElementContext<App.MerchandiseFilters | null>()

  // Track the latest merged filters from SearchFilters component
  const latestMergedFiltersRef = useRef<App.MerchandiseFilters>(userFilters)

  const onFilterChange = useCallback((_formFilters: MerchandiseFilterFacetForm, mergedFilters?: App.MerchandiseFilters) => {
    // Keep track of latest merged filters
    if (mergedFilters) {
      latestMergedFiltersRef.current = mergedFilters
    }
  }, [])

  const onApplyFilters = useCallback<React.FormEventHandler<HTMLFormElement>>((e) => {
    e.preventDefault()
    // Return the latest merged filters (not raw form data)
    resolve(latestMergedFiltersRef.current)
  }, [resolve])

  const onResetFilters = useCallback(() => {
    resolve(null)
  }, [resolve])

  return <FormModal
    title={intl.formatMessage({
      id: 'lNYinJ4g3N',
      defaultMessage: 'Filters',
      description: 'Title for merchandise filter modal',
    })}
    primaryActionText={intl.formatMessage({
      id: 'Mt7Fn1fKZd',
      defaultMessage: 'View products',
      description: 'Button text to apply filters and view merchandise products',
    })}
    onSubmit={onApplyFilters}
    secondaryActionText={intl.formatMessage({
      id: '4r7pXvom4w',
      defaultMessage: 'Reset all',
      description: 'Button text to reset all merchandise filters',
    })}
    onSecondaryActionClick={onResetFilters}
  >
    {children || <MerchandiseSearchFilters
      userFilters={userFilters}
      category={category}
      urlFilters={urlFilters}
      onChange={onFilterChange}
    />}
  </FormModal>
}

export default MerchandiseSearchFilterModal
